/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import useEventRouting from "hooks/useEventRouting";

const usePreviousRoute = (base: string) => {
  const { navigateWithEvent } = useEventRouting();
  const routeBack = (direction?: any) => {
    if (direction && typeof direction === "string")
      return navigateWithEvent(direction);

    // if there is a previous route, go back to it
    if (window.history.state && window.history.state.idx > 0) {
      navigateWithEvent(-1);
    } else {
      // there is no previous route, therefore go to the base.
      navigateWithEvent(base);
    }
  };
  return routeBack;
};

export default usePreviousRoute;
